<template lang="pug">
  e-modal(
    title="Выберите тип участника"
    saveBtnLabel="Создать"
    :autoHeight="true"
    @close="$emit('close')"
    @confirm="showCreateWindow()"
  )
    slot
      .body
        .choose-member
          e-radio(
            name="role_id"
            :options="roles"
            :model="fields"
            tabView="tab1"
            @change='changeMember'
          ).radio-block

          div.choose-member__block(
            v-if="isOwnerMember"
          )
            label.semibold.label.choose-member__label Выберите тип собственника
            e-select(
              name="owner_type"
              :model="fields"
              :options="ownerTypes"
              :hidePlaceholder='true'
            )

</template>

<script>
import url from '@/utils/url'

const MEMBER_TYPES = {
  operator: 1,
  owner: 2,
}

export default {
  name: 'member-type',
  data: () => ({
    isOwnerMember: false,
    fields: {
      role_id: 1,
      owner_type: 'company',
    },
    roles: [
      { id: 1, name: 'Оператор' },
      { id: 2, name: 'Собственник' },
    ],
    ownerTypes: [
      { id: 'company', name: 'Юридическое лицо' },
      { id: 'ip', name: 'Индивидуальный предприниматель' },
      { id: 'person', name: 'Физическое лицо' },
    ],
  }),
  methods: {
    changeMember(event) {
      this.isOwnerMember = Number(event.target.value) === MEMBER_TYPES.owner
    },
    showCreateWindow() {
      this.$emit('close')
      let name = 'registry.operators.create'
      let params = {}
      if (this.isOwnerMember) {
        name = 'owner.update'
        params = {
          owner_type: this.fields.owner_type,
        }
      }
      this.$router.push({
        name,
        params,
        query: {
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
  },
}
</script>
